import axios from "axios";
import { API_URL } from "../apiurl";
import { TOKEN_KEY } from "../../config/variable";

const isSavedInStorage =
  localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

export const MultiDelete = async (deleteArrayIds) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: `
          mutation MultiDeleteSecurityReport($deleteArrayIds: [ID!]!) {
            multiDeleteSecurityReport(deleteArrayIds: $deleteArrayIds) {
              success
              status
              message
              data
              error
            }
          }
        `,
        variables: {
          deleteArrayIds,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(isSavedInStorage)?.token,
        },
      }
    );

    return response?.data?.data?.multiDeleteSecurityReport;
  } catch (error) {
    console.error("MultiDelete Error:", error);
    throw error;
  }
};
export const MultiTempDelete = async (deleteArrayIds) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: `
          mutation MultiTemporaryDeleteSecurityReport($deleteArrayIds: [ID!]!, $deletedAt:String) {
            multiTemporaryDeleteSecurityReport(deleteArrayIds: $deleteArrayIds, deletedAt:$deletedAt) {
              success
              status
              message
              data
              error
            }
          }
        `,
        variables: {
          deleteArrayIds,
          deletedAt: new Date().toISOString(),
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(isSavedInStorage)?.token,
        },
      }
    );

    return response?.data?.data?.multiTemporaryDeleteSecurityReport;
  } catch (error) {
    console.error("MultiDelete Error:", error);
    throw error;
  }
};


// console.log("idisSavedInStorage", JSON.parse(isSavedInStorage)?.token);
export const TempDeleteAPI = async (reportId) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: `
          mutation TemporaryDeleteSecurityReport($reportId: ID!, $deletedAt: String) {
            temporaryDeleteSecurityReport(reportId: $reportId, deletedAt: $deletedAt) {
              success
              status
              message
              data
              error
            }
          }
        `,
        variables: {
          reportId,
          deletedAt: new Date().toISOString(),
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(isSavedInStorage)?.token,
        },
      }
    );

    return response?.data?.data?.temporaryDeleteSecurityReport;
  } catch (error) {
    console.error("Temporary Delete Error:", error);
    throw error;
  }
};
export const RetrieveDeletedReportAPI = async (reportId) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: `
          mutation RetrieveDeleteSecurityReport($reportId: ID!) {
            retrieveDeleteSecurityReport(reportId: $reportId) {
              success
              status
              message
              data
              error
            }
          }
        `,
        variables: {
          reportId,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(isSavedInStorage)?.token,
        },
      }
    );

    return response?.data?.data?.retrieveDeleteSecurityReport;
  } catch (error) {
    console.error("Temporary Delete Error:", error);
    throw error;
  }
};


export const DeleteSecurityReportAPI = async (templateId) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: `
          mutation DeleteSecurityReport($templateId: ID!) {
            deleteSecurityReport(templateId: $templateId) {
              success
              status
              message
              data
              error
            }
          }
        `,
        variables: {
          templateId,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(isSavedInStorage)?.token,
        },
      }
    );

    return response?.data?.data?.deleteSecurityReport;
  } catch (error) {
    console.error("DeleteSecurityReportAPI Error:", error);
    throw error;
  }
};

